module.exports = __webpack_public_path__ + "150ef3c4fd892fd492bcd0118624c94e.png";